define('maprenderer',[
  'settings', 'hooks'
], function(Settings, Hooks) {
  var gmaps = [];
  var MapRenderer = {};

  function get_map_el(event_settings) {
    var id = event_settings.map.id;
    return document.getElementById(id);
  }

  function add_marker(marker_data, map) {
    var marker = new google.maps.Marker({
      position: new google.maps.LatLng(marker_data.latitude,
                                       marker_data.longitude),
      map: map
    });

    marker.info_window = new google.maps.InfoWindow({
      content: marker_data.text
    });
    google.maps.event.addListener(marker, 'click', function() {
      marker.info_window.open(map, marker);
    });

    return marker;
  }

  MapRenderer.render_maps = function(event_settings) {
    Hooks.mapRendererBeginsRendering(event_settings);

    if (!event_settings) {
      return false;
    }

    var map_el = get_map_el(event_settings);
    var map_options = {
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var gmap = new google.maps.Map(map_el, map_options);

    var bounds = new google.maps.LatLngBounds();
    var good_locations = 0;
    for (var i in event_settings.map.markers) {
      var marker_data = event_settings.map.markers[i];
      var marker = add_marker(marker_data, gmap);
      Hooks.mapRendererAddedMarker(marker);
      bounds.extend(marker.position);
      good_locations += 1;
    }

    if (good_locations > 0) {
      gmap.fitBounds(bounds);
      gmaps.push(gmap);
      Hooks.mapRendererPushedMap(gmap);

      if (typeof map_el !== 'undefined' && map_el !== null) {
        if (!map_el.className) {
          map_el.className = '';
        }

        map_el.className += " has-locations";
      }
    }

    Hooks.mapRendererFinishedRendering(event_settings);

    return true;
  }

  return MapRenderer;

});

